export default function handleDeerFlowPostMessageCleanup({ isDeerFlow, effectiveSessionId, deerFlowHook }) {
    if (isDeerFlow && effectiveSessionId) {
        // 清除可能存在的延迟启动定时器
        try {
            if (deerFlowHook?.delayedStartTimers?.current?.has(effectiveSessionId)) {
                clearTimeout(deerFlowHook.delayedStartTimers.current.get(effectiveSessionId));
                deerFlowHook.delayedStartTimers.current.delete(effectiveSessionId);
            }
        } catch (e) {
            // ignore
        }

        // 不再由 useChat 启动轮询，只做状态更新与延迟清理
        const delayTimer = setTimeout(async () => {
            try {
                deerFlowHook.delayedStartTimers.current.delete(effectiveSessionId);
            } catch (e) {
                // ignore
            }
        }, 1000);

        // 存储延迟定时器引用
        try {
            deerFlowHook.delayedStartTimers.current.set(effectiveSessionId, delayTimer);
        } catch (e) {
            // ignore
        }
    }

    // 消息处理完成后，只有不在修改计划模式时才重置按钮禁用状态
    try {
        if (!deerFlowHook?.editPlanMode) {
            setTimeout(() => {
                try {
                    deerFlowHook.setPlanButtonsDisabled(false);
                } catch (e) {
                    // ignore
                }
            }, 300);
        }
    } catch (e) {
        // ignore
    }
}


